import { PayoutInformationAccount } from "Shared/util/types/api";
import { DataTableItem } from "../types";

export const getRowId = ({
    customerPaymentMethodId,
    openBankingAccountId,
}: DataTableItem): string =>
    `${customerPaymentMethodId}::${openBankingAccountId}`;

export const isRowSelected = ({ isPayoutAccount }: DataTableItem): boolean =>
    isPayoutAccount;

export const isSelectableRowDisabled = ({
    isPrimary,
    openBankingAccountId,
}: DataTableItem) => isPrimary || !openBankingAccountId;

export const isSelectedAccount = (
    openBankingAccountId: number | null,
    customerPaymentMethodId: number | null,
    previousState: PayoutInformationAccount,
): boolean =>
    (!!previousState?.openBankingAccountId &&
        previousState.openBankingAccountId === openBankingAccountId) ||
    (!!previousState?.customerPaymentMethodId &&
        previousState.customerPaymentMethodId === customerPaymentMethodId);
